import React, { useState } from "react";
import axios from "axios";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ContactForm() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: "",
    });
    const [loading, setLoading] = useState(false);

    const onChange = (k) => (e) =>
        setForm((s) => ({ ...s, [k]: e.target.value }));

    const onSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.message) {
            toast.error("Please share your name, email, and a short message.");
            return;
        }
        try {
            setLoading(true);
            await axios.post(`${API}/contact`, form);
            toast.success(
                "Thank you for reaching out — we'll respond shortly.",
            );
            setForm({
                name: "",
                email: "",
                phone: "",
                subject: "",
                message: "",
            });
        } catch (err) {
            toast.error("Something went wrong. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <form
            onSubmit={onSubmit}
            className="space-y-6"
            data-testid="contact-form"
        >
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                <div className="space-y-2">
                    <Label className="ssh-eyebrow text-[#75736F]">Name</Label>
                    <Input
                        value={form.name}
                        onChange={onChange("name")}
                        className="bg-white border-[#EFEBE4] rounded-none h-12 focus-visible:ring-[#8A9A86]"
                        data-testid="contact-input-name"
                        placeholder="Your name"
                    />
                </div>
                <div className="space-y-2">
                    <Label className="ssh-eyebrow text-[#75736F]">Email</Label>
                    <Input
                        type="email"
                        value={form.email}
                        onChange={onChange("email")}
                        className="bg-white border-[#EFEBE4] rounded-none h-12 focus-visible:ring-[#8A9A86]"
                        data-testid="contact-input-email"
                        placeholder="you@example.com"
                    />
                </div>
                <div className="space-y-2">
                    <Label className="ssh-eyebrow text-[#75736F]">Phone</Label>
                    <Input
                        value={form.phone}
                        onChange={onChange("phone")}
                        className="bg-white border-[#EFEBE4] rounded-none h-12 focus-visible:ring-[#8A9A86]"
                        data-testid="contact-input-phone"
                        placeholder="Optional"
                    />
                </div>
                <div className="space-y-2">
                    <Label className="ssh-eyebrow text-[#75736F]">
                        Subject
                    </Label>
                    <Input
                        value={form.subject}
                        onChange={onChange("subject")}
                        className="bg-white border-[#EFEBE4] rounded-none h-12 focus-visible:ring-[#8A9A86]"
                        data-testid="contact-input-subject"
                        placeholder="What's this about?"
                    />
                </div>
            </div>
            <div className="space-y-2">
                <Label className="ssh-eyebrow text-[#75736F]">Message</Label>
                <Textarea
                    value={form.message}
                    onChange={onChange("message")}
                    className="bg-white border-[#EFEBE4] rounded-none min-h-[160px] focus-visible:ring-[#8A9A86]"
                    data-testid="contact-input-message"
                    placeholder="Take your time — share what's true for you."
                />
            </div>
            <div className="pt-2">
                <Button
                    type="submit"
                    disabled={loading}
                    className="ssh-btn-primary rounded-none px-10 py-6 text-xs uppercase tracking-[0.22em]"
                    data-testid="contact-submit"
                >
                    {loading ? "Sending..." : "Send Message"}
                </Button>
            </div>
        </form>
    );
}
